<template>
  <app-modal
    v-bind="$attrs"
    ref="modal"
    class="modal-container"
    content-class="modal-large-plus"
    title="エクストラサイト設定(Type4)"
  >
    <template v-if="isLoaded" v-slot:body="{ cancel }">
      <validation-observer
        v-slot="{ handleSubmit }"
        :initial-values="{ addressList: extraData.addressList }"
        as="div"
      >
        <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
          <div class="modal-body">
            <v-card-text class="pa-0">
              <v-container>
                <v-row>
                  <v-col cols="5">
                    <app-badge
                      :item="extraSite === null ? '新規サイト名' : 'サイト名'"
                      :msg="
                        $filter.message('info_max_length', { maxLength: 20 })
                      "
                      placement="end"
                    />
                    <validation-provider
                      name="siteName"
                      label="サイト名"
                      v-model="extraData.siteName"
                      :rules="{
                        max: { length: 20 },
                        required: true,
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        v-bind="componentField"
                        :error-messages="errorMessage"
                        :field-meta="meta"
                        :disabled="isPolicy && extraSite !== null"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col :cols="extraSite === null ? 5 : 4">
                    <app-badge
                      item="アドレス名"
                      :msg="
                        $filter.message('info_max_length', { maxLength: 20 })
                      "
                      :isRequired="false"
                      placement="end"
                    />
                  </v-col>
                  <v-col :cols="extraSite === null ? 5 : 4">
                    <app-badge
                      item="アドレス"
                      :msg="
                        $filter.message(
                          'info_cidr_ip_address_of_network_address',
                          {
                            ipaddress1: '192.168.0.0/24',
                            genre: 'アドレス',
                            subnet1: '1',
                            subnet2: '30',
                            ipaddress2: '192.168.0.1/32',
                          }
                        )
                      "
                      :is-required="
                        hasInputIpAddressName ||
                        extraData.addressList.length !== 1
                      "
                      placement="end"
                    />
                  </v-col>
                  <v-col v-if="extraSite !== null">
                    <app-badge
                      item="ポリシー使用有無"
                      :isRequired="false"
                      :is-info="false"
                    />
                  </v-col>
                </v-row>
                <validation-array
                  name="addressList"
                  v-slot="{ fields, push, remove }"
                >
                  <template v-for="(item, index) in fields" :key="item.key">
                    <v-row>
                      <v-col :cols="extraSite === null ? 5 : 4">
                        <validation-provider
                          label="アドレス名"
                          :name="`ipAddressName_${item.key}`"
                          v-model="extraData.addressList[index].ipAddressName"
                          :rules="{
                            max: { length: 20 },
                            duplicate: { list: existsIpAddressNm(index) },
                          }"
                          v-slot="{ componentField, errorMessage, meta }"
                        >
                          <app-form-input
                            v-bind="componentField"
                            :error-messages="errorMessage"
                            :field-meta="meta"
                            :disabled="
                              extraData.addressList[index].isPolicyInUse ||
                              (isPolicy &&
                                extraData.addressList[index].ipAddressId !==
                                  null)
                            "
                          />
                        </validation-provider>
                      </v-col>
                      <v-col :cols="extraSite === null ? 5 : 4">
                        <validation-provider
                          label="アドレス"
                          :name="`address_${item.key}`"
                          v-model="extraData.addressList[index].ipAddress"
                          :rules="{
                            required:
                              !!extraData.addressList[index].ipAddressName ||
                              extraData.addressList.length !== 1,
                            is_ip_subnet: { min: 1, max: 32, exclude: [31] },
                            is_not_current_ip: true,
                            is_not_loopback_ip: true,
                            is_not_multicast_ip: true,
                            is_not_class_e_ip: true,
                            is_not_broadcast_ip: true,
                            is_network_address: true,
                            duplicate: { list: existsIpAddress(index) },
                          }"
                          v-slot="{ componentField, errorMessage, meta }"
                        >
                          <app-form-input
                            v-bind="componentField"
                            :error-messages="errorMessage"
                            :field-meta="meta"
                            :disabled="
                              extraData.addressList[index].isPolicyInUse ||
                              (isPolicy &&
                                extraData.addressList[index].ipAddressId !==
                                  null)
                            "
                            :placeholder="
                              $filter.message(
                                'placeholder_ip_address_of_private_network_address'
                              )
                            "
                          />
                        </validation-provider>
                      </v-col>
                      <v-col v-if="extraSite !== null" cols="3">
                        <div class="ml-5 mt-2">
                          <span>{{
                            $filter.enumTo(
                              extraData.addressList[index].isPolicyInUse,
                              "isPolicyInUse"
                            )
                          }}</span>
                        </div>
                      </v-col>
                      <v-col
                        :cols="extraSite === null ? 2 : 1"
                        v-if="
                          (!extraData.addressList[index].isPolicyInUse &&
                            !isPolicy) ||
                          (extraData.addressList[index].ipAddressId === null &&
                            isPolicy)
                        "
                        class="text-end"
                      >
                        <v-btn
                          icon="$mdiMinus"
                          size="small"
                          variant="outlined"
                          class="rounded-sm"
                          @click="removeIPAddress(index, remove)"
                        />
                      </v-col>
                    </v-row>
                  </template>
                  <v-row justify="end" class="text-end">
                    <v-col cols="2">
                      <v-btn
                        icon="$mdiPlus"
                        size="small"
                        variant="outlined"
                        class="rounded-sm"
                        @click="addIPAddress(push)"
                      />
                    </v-col>
                  </v-row>
                </validation-array>
              </v-container>
            </v-card-text>
          </div>

          <v-divider></v-divider>
          <!-- FOOTER -->
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:append>
                <v-btn type="submit" variant="flat" color="primary">{{
                  extraSite === null ? "追加" : "変更"
                }}</v-btn>
                <v-btn variant="outlined" color="primary" @click="cancel">
                  キャンセル
                </v-btn>
              </template>
            </v-list-item>
          </v-card-actions>
        </v-form>
      </validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import type { ApplianceInfo } from "@/apis/ContractApi";
import cloneDeep from "lodash/cloneDeep";
import type {
  PostType4ExtraSite,
  PostType4ExtraSiteAddress,
  ResultPostType4ExtraSite,
  Type4ExtraSite,
  Type4ExtraSiteList,
  Type4SiteEdit,
  Type4SiteEditAddressList,
} from "@/apis/Type4SiteApi";
import Type4ExtraSiteConfirmModal from "@/modals/type4/Type4ExtraSiteConfirmModal.vue";
import { VueFinalModal } from "vue-final-modal";

export default defineComponent({
  name: "Type4ExtraSiteEdit",
  props: {
    extraSite: {
      type: Object as PropType<Type4ExtraSiteList | null>,
      default: null,
    },
    type4Id: {
      type: String as PropType<ApplianceInfo["type4Id"]>,
      required: true,
    },
    type4SiteKeyId: {
      type: String as PropType<Type4ExtraSite["type4SiteKeyId"]>,
      required: true,
    },
  },

  data() {
    return {
      /** 詳細データ */
      extraData: {} as Type4SiteEdit,
      keyId4AddrRegister: "",
      isLoaded: false,
    };
  },
  computed: {
    /** 既存のIPアドレス名 */
    existsIpAddressNm() {
      // 既存のアドレス名リストに同じIPアドレス名が存在した場合はエラーとする
      return (index: number) => {
        return this.extraData.addressList
          .filter((_, num) => num !== index)
          .map((v) => v.ipAddressName);
      };
    },
    /** 既存のIPアドレス */
    existsIpAddress() {
      // 既存のアドレスリストに同じIPアドレスが存在した場合はエラーとする
      return (index: number) => {
        return this.extraData.addressList
          .filter((_, num) => num !== index)
          .map((v) => v.ipAddress);
      };
    },
    /** 入力済みIPアドレス一覧 */
    inputIpAddresses(): Type4SiteEditAddressList[] {
      return this.extraData.addressList.filter((e) => e.ipAddress);
    },
    /** アドレス名入力済みの場合は,true */
    hasInputIpAddressName(): boolean {
      return this.extraData.addressList.some((v) => v.ipAddressName);
    },
    /** 遷移元がポリシー設定の場合は,true */
    isPolicy(): boolean {
      return this.$route.path === "/network/contract";
    },
  },
  mounted() {
    this.load();
    this.isLoaded = true;
  },

  methods: {
    /**
     * 初期化機能
     * システム上の配置状態追加(addressList)
     */
    load() {
      // 追加モードdefault値の設定
      if (this.extraSite === null) {
        this.extraData = {
          siteId: "",
          siteName: "",
          addressList: [
            {
              ipAddressId: null,
              ipAddressName: "",
              ipAddress: "",
              isPolicyInUse: false,
            },
          ],
        };
      } else {
        // 変更モード値のコピー
        this.extraData = cloneDeep(this.extraSite);
        if (this.extraData.addressList.length < 1)
          this.extraData.addressList.push({
            ipAddressId: null,
            ipAddressName: "",
            ipAddress: "",
            isPolicyInUse: false,
          });
        else if (this.isPolicy)
          this.extraData.addressList.push({
            ipAddressId: null,
            ipAddressName: "",
            ipAddress: "",
            isPolicyInUse: false,
          });
      }
    },
    /** 追加、変更機能 */
    async submit() {
      if (this.extraData.siteId) {
        this.keyId4AddrRegister = this.keyId4AddrRegister
          ? this.keyId4AddrRegister
          : this.type4SiteKeyId;
        // 変更機能
        await this.$modal.show(Type4ExtraSiteConfirmModal, {
          message: "エクストラサイト設定を変更します。よろしいですか？",
        });
        // 変更APIを呼び出す
        await this.postExtraSiteModifyApi();
      } else {
        // 追加機能
        await this.$confirm("エクストラサイトを追加します。よろしいですか？");
        // 追加データの設定
        const postData: PostType4ExtraSite = {
          siteName: this.extraData.siteName,
          type4SiteKeyId: this.type4SiteKeyId,
        };
        // レスポンスデータの取得
        const resultData: ResultPostType4ExtraSite =
          await this.$api.type4SiteApi.postType4ExtraSiteRegister(
            this.type4Id,
            postData
          );

        this.extraData.siteId = resultData.siteId;
        this.keyId4AddrRegister = resultData.type4SiteKeyId;

        // 変更APIを呼び出す
        if (this.inputIpAddresses.length > 0) {
          await this.postExtraSiteModifyApi();
        }
      }
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
    /**
     * エクストラサイト変更APIを呼び出す
     */
    async postExtraSiteModifyApi() {
      // 変更APIデータの設定
      const reqData: PostType4ExtraSiteAddress = {
        siteName: this.extraData.siteName,
        addressList: this.inputIpAddresses.map((e) => ({
          ipAddressId: e.ipAddressId,
          ipAddressName: e.ipAddressName || null,
          ipAddress: e.ipAddress,
        })),
        type4SiteKeyId: this.keyId4AddrRegister,
      };
      await this.$api.type4SiteApi.postType4ExtraSiteModify(
        this.extraData.siteId,
        this.type4Id,
        reqData
      );
    },
    /**
     * IPAddress追加機能
     * 押下時一行追加
     */
    addIPAddress(push: (item: any) => void) {
      const addItem = {
        ipAddressId: null,
        ipAddressName: "",
        ipAddress: "",
        isPolicyInUse: false,
      };
      this.extraData.addressList.push(addItem);
      push(addItem);
    },
    /**
     * IPAddress削除機能
     * 押下時その行削除
     * 一行しかない場合その行クリア
     */
    removeIPAddress(index: number, remove: (idx: number) => void) {
      if (this.extraData.addressList.length > 1) {
        this.extraData.addressList.splice(index, 1);
        remove(index);
      } else {
        this.extraData.addressList = [
          {
            ipAddressId: null,
            ipAddressName: "",
            ipAddress: "",
            isPolicyInUse: false,
          },
        ];
      }
    },
  },
});
</script>
<style lang="scss" scoped>
.modal-body {
  min-height: 55vh;
}
</style>
